import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog zum Löschen eines Fotos.
 */
function DeletePhotoDialog({ open, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.photo_delete.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.photo_delete.confirm')}
          </p>
        </div>
        <div className="edit-actions">
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.delete')}
          </button>
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeletePhotoDialog;
